import PropTypes from 'prop-types'
import { Card } from 'react-bootstrap'
import { Typography } from '../styled'
import theme from '../../constants/theme'
import QuestionInput from './inputs/QuestionInput'
import { QuestionCard, QuestionNumber } from './styles'

function QuestionItem({ index, question, value, onChange, onUploading }) {
  return (
    <QuestionCard className="mb-4 border-0 shadow-sm">
      <Card.Body className="p-4">
        <div className="mb-3 d-flex align-items-start gap-2">
          <QuestionNumber>{index + 1}</QuestionNumber>
          <Typography
            bold
            size="15px"
            color={theme.talentinoBlack}
            className="mt-1"
          >
            {question.question}
          </Typography>
        </div>
        <QuestionInput
          question={question}
          value={value}
          onChange={onChange}
          onUploading={onUploading}
        />
      </Card.Body>
    </QuestionCard>
  )
}

QuestionItem.propTypes = {
  index: PropTypes.number.isRequired,
  question: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    question: PropTypes.string,
    answerType: PropTypes.string,
  }).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({}),
  ]),
  onChange: PropTypes.func.isRequired,
  onUploading: PropTypes.func,
}

export default QuestionItem
